import {MiddlewareType} from 'middlewares'
import {history} from 'utils/history'
import {update} from 'ramda'

import {
  OVERLAY_SHOW,
  OVERLAY_HIDE,
  OVERLAY_REPLACE_TOP
} from 'modules/overlay/actions'

const middleware: MiddlewareType = store => next => action => {
  const state = store.getState()

  next(action)

  switch (action.type) {
    case OVERLAY_SHOW: {
      if (action.ignoreHistory) break

      history.push(`${history.location.pathname}${history.location.search}`, {
        locationState: {
          overlays: [...state.overlay, action.params]
        }
      })
      break
    }

    case OVERLAY_HIDE: {
      if (action.ignoreHistory) break
      history.goBack()
      break
    }

    case OVERLAY_REPLACE_TOP: {
      history.replace(
        `${history.location.pathname}${history.location.search}`,
        {
          locationState: {
            overlays: update(
              state.overlay.length - 1,
              action.params,
              state.overlay
            )
          }
        }
      )
      break
    }

    default:
      break
  }
}

export default middleware
